export const environment = {
  production: true,
  apiLink: "https://portalapi.hugeconnect.co.za/api",
  // apiLink: 'http://10.0.3.97:17075/api',
  // dsn: 'https://e93c62cdcde44425b2acc1ac85485234@o1178364.ingest.sentry.io/6298835',
  dsn: '',
  tracesSampleRate: 1.0,
};
